import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'
import { validateEnvironment } from './lib/env-check'

// Validate environment variables first
validateEnvironment()

// Freeze the safe-area inset once, so fixed elements (bottom nav) don't visibly
// jump when iOS Safari's URL bar collapses/expands during scroll and the live
// env(safe-area-inset-bottom) value toggles between ~0 and ~34px.
// We measure with a probe div using the native env() value, then lock it as
// --app-safe-bottom for the rest of the session.
function freezeSafeAreaInsetBottom() {
  const probe = document.createElement('div')
  probe.style.cssText = 'position:fixed;left:0;bottom:0;width:0;height:env(safe-area-inset-bottom,0px);pointer-events:none;visibility:hidden;'
  document.body.appendChild(probe)
  // Wait one frame so layout reflects the actual env() value.
  requestAnimationFrame(() => {
    const px = Math.round(probe.getBoundingClientRect().height)
    document.documentElement.style.setProperty('--app-safe-bottom', `${px}px`)
    probe.remove()
  })
}
if (document.readyState === 'complete') freezeSafeAreaInsetBottom()
else window.addEventListener('load', freezeSafeAreaInsetBottom, { once: true })
// Sensible fallback until the probe runs.
document.documentElement.style.setProperty('--app-safe-bottom', '0px')

// Clear any stale ServiceWorker cache
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
      console.log('ServiceWorker unregistered:', registration)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
